import { HeaderData } from './types';

export const URL_ROUTES = {
  landingPage: '/dtna-paragon-part-order',
  newOrderTransmissionPage: '/dtna-paragon-part-order/new-order-transmission',
  partOrderDetailPage:'/dtna-paragon-part-order/part-order-detail'
};

export const DEFAULT_HEADER_DATA: HeaderData = {
  'x-department-name': '',
  remote_user: '',
  'x-enterprise-id': '',
  'x-store-id': '',
  authorization: '',
  'Content-Type': 'application/json',
  'x-department-type': '',
};

export const METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
};

export const permissions = {
  ACCESS_PPOE: 'ACCESS_PPOE',
};

export const PPOE_PERMISSIONS = Object.values(permissions);

export const CHEETAH_ROUTE = {
  MFE_PO_ACCESS_DENIED: '/access-denied',
  MFE_PO_ERROR: '/error',
};

export enum ReactEnvironments {
  Develop = 'us-dev',
  Staging = 'us-stage',
  Production = 'us-prod',
  Perf = 'us-perf',
  Local = 'local',
  PreProd = 'preprod',
}

export const API_ENV: string = process.env.REACT_APP_ENV || ReactEnvironments.Develop;

// Okta setup constants

export type ObjectTypes = {
  [key: string]: string;
};

// PPOE need to
export const OKTA_CLIENT_ID: ObjectTypes = {
  [ReactEnvironments.Production]: '0oa11xvzbnuCEj1WD1t8',
  [ReactEnvironments.Perf]: '0oa1by6v0nrD36eRg0h8',
  [ReactEnvironments.Staging]: '0oa1by6v0nrD36eRg0h8',
  [ReactEnvironments.Develop]: '0oa25l2p7bl6HvUiN0h8',
  [ReactEnvironments.Local]: '0oa1by6v0nrD36eRg0h8',
};

export const OKTA_ISSUER: ObjectTypes = {
  [ReactEnvironments.Local]:
    'https://connectcdk-dit.oktapreview.com/oauth2/default',
  [ReactEnvironments.Develop]:
    'https://connectcdk-dit.oktapreview.com/oauth2/default',
  [ReactEnvironments.Staging]:
    'https://connectcdk-dit.oktapreview.com/oauth2/default',
  [ReactEnvironments.Perf]:
    'https://connectcdk-dit.oktapreview.com/oauth2/default',
  [ReactEnvironments.Production]: 'https://connectcdk.okta.com/oauth2/default',
};
  

export const OKTA_LOG_OFF: ObjectTypes = {
  [ReactEnvironments.Local]: 'https://login-dit.connectcdk.com/sso/logoff',
  [ReactEnvironments.Develop]: 'https://login-dit.connectcdk.com/sso/logoff',
  [ReactEnvironments.Staging]: 'https://login-dit.connectcdk.com/sso/logoff',
  [ReactEnvironments.Perf]: 'https://login-dit.connectcdk.com/sso/logoff',
  [ReactEnvironments.Production]: 'https://login.connectcdk.com/sso/logoff',
};

export const OKTA_AUTHORIZE_URIS: ObjectTypes = {
  [ReactEnvironments.Local]:
    'https://api-dit.connectcdk.com/api/cs-common-login-api/v1/authorize',
  [ReactEnvironments.Develop]:
    'https://api-dit.connectcdk.com/api/cs-common-login-api/v1/authorize',
  [ReactEnvironments.Staging]:
    'https://api-dit.connectcdk.com/api/cs-common-login-api/v1/authorize',
  [ReactEnvironments.Perf]:
    'https://api-dit.connectcdk.com/api/cs-common-login-api/v1/authorize',
  [ReactEnvironments.Production]: 'https://login.connectcdk.com/login/authorize',
};

export const HA_OKTA_AUTHORIZE_URIS: ObjectTypes = {
  [ReactEnvironments.Local]:
    'https://cml-api-nginx.global-dit.connectcdk.com/authorize',
  [ReactEnvironments.Develop]:
    'https://cml-api-nginx.global-dit.connectcdk.com/authorize',
  [ReactEnvironments.Staging]:
    'https://cml-api-nginx.global-dit.connectcdk.com/authorize',
  [ReactEnvironments.Perf]:
    'https://cml-api-nginx.global-dit.connectcdk.com/authorize',
  [ReactEnvironments.Production]: 'https://login.connectcdk.com/login/authorize',
};

export const OKTA_TOKEN_URL: ObjectTypes = {
  [ReactEnvironments.Local]:
    'https://api-dit.connectcdk.com/api/cs-common-login-api/v1/token',
  [ReactEnvironments.Develop]:
    'https://api-dit.connectcdk.com/api/cs-common-login-api/v1/token',
  [ReactEnvironments.Staging]:
    'https://api-dit.connectcdk.com/api/cs-common-login-api/v1/token',
  [ReactEnvironments.Perf]:
    'https://api-dit.connectcdk.com/api/cs-common-login-api/v1/token',
  [ReactEnvironments.Production]:
    'https://api.connectcdk.com/api/cs-common-login-api/v1/token',
};

export const HA_OKTA_TOKEN_URL: ObjectTypes = {
  [ReactEnvironments.Local]:
    'https://cml-api-nginx.global-dit.connectcdk.com/token',
  [ReactEnvironments.Develop]:
    'https://cml-api-nginx.global-dit.connectcdk.com/token',
  [ReactEnvironments.Staging]:
    'https://cml-api-nginx.global-dit.connectcdk.com/token',
  [ReactEnvironments.Perf]:
    'https://cml-api-nginx.global-dit.connectcdk.com/token',
  [ReactEnvironments.Production]:
    'https://cml-api-nginx.global.connectcdk.com/token',
};

export const QUERY_TIME = {
  FIVE_MINUTES: 1000 * 60 * 5,
  TEN_MINUTES: 1000 * 60 * 10,
  THREE_MINUTES: 1000 * 60 * 3,
  ONE_HOUR: 1000 * 60 * 60,
  ONE_DAY: 1000 * 60 * 60 * 24,
};

export const TOAST_VISIBILITY_DURATIONS = {
  EIGHT_SECONDS: 8000,
  INFINITE: 0,
  SEVEN_SECONDS: 7000,
  SIX_SECONDS: 6000,
};

export const LOCALE = {
  ENGLISH: 'en_US',
  FRENCH: 'fr_CA',
};

export const LANGUAGE = {
  ENGLISH: 'en',
  FRENCH: 'fr',
};
